export default __webpack_public_path__ + "static/media/eye-close.bd6f467a.svg";